var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AgItem',{attrs:{"rowData":_vm.rowData,"columnDefs":_vm.columnDefs,"min-height":"164px","height-type":"matchRows"}})}
var staticRenderFns = []

export { render, staticRenderFns }